import { Component, Input, OnInit } from '@angular/core';
import { SearchResultEquipment } from 'src/app/models/search/search-result-equipment';
import { ReturnSurveyEquipment } from 'src/app/models/survey-equipment/return-survey-equipment';

@Component({
  selector: 'app-equipment-card',
  templateUrl: './equipment-card.component.html',
  styleUrls: ['./equipment-card.component.scss'],
})
export class EquipmentCardComponent implements OnInit {

  private _value: EquipmentCardModel = null;
  get model(): SearchResultEquipment | ReturnSurveyEquipment {
    return this._value;
  }

  @Input('equipment')
  set model(val: SearchResultEquipment | ReturnSurveyEquipment) {
    this._value = Object.assign({} as EquipmentCardModel, val);
  }
  
  constructor() { }

  ngOnInit() {}

}

interface EquipmentCardModel {
  id: string;
  description: string;
  entitytype: string;
  serialNumber: string;
  contractNumber: string;
  subLocation: string;
  creationDate: Date;
  existingAddress: string;
  status: string;
  type: string;
  make: string;
  model: string;
  addressId: string;
  addressType: string;
  customerNumber: string;
  addressCode: string;
  equipmentId: string;
  manufacturerId: string;
  modelNumber: string;
  sublocationId: string;
  installationDate: string;
  installationBy: string;
  warrantyExpires: string;
  extendedWarranty: string;
  extendedwarrantyExpires: string;
  serviceLevelId: string;
  barCodeId: string;
  userDefine1a: string;
  userDefine2a: string;
  userDefine3a: string;
  userDefine4a: string;
  userDefine5a: string;
  userDefine9a: string;
  createdBy: number;
  createdDate: string;
  modifiedBy: number;
  modifiedDate: string;
  generateGpEquipmentId: boolean;
  suspendMccCalls: boolean;
  isSurveyEquipment: boolean;
  prospectCustomerAddressId?: number;
}